import { d as stripQueryParam, f as toQueryString, i as getQueryParam, l as mergeQueryParam } from "./utils-CT_1OHHh.js";
import { useCallback, useMemo } from "react";
import { identity, pickBy } from "lodash-es";
import { useHistory, useLocation } from "react-router-dom";
//#region src/UrlQueryParam/useUrlQueryParam.ts
function useUrlQueryParam(paramKey, defaultValue = "") {
	const { search } = useLocation();
	const history = useHistory();
	const rawQueryParam = getQueryParam(search, paramKey);
	const setQueryParam = useCallback((value) => {
		const newSearch = mergeQueryParam(search, paramKey, value);
		history.replace({ search: newSearch });
	}, [
		search,
		paramKey,
		history
	]);
	const removeQueryParam = useCallback(() => {
		const newSearch = stripQueryParam(search, paramKey);
		history.replace({ search: newSearch });
	}, [
		search,
		paramKey,
		history
	]);
	return {
		queryParam: rawQueryParam || defaultValue,
		setQueryParam,
		removeQueryParam
	};
}
//#endregion
//#region src/UrlQueryParam/useUrlQueryParams.ts
function useUrlQueryParams(defaultValues) {
	const { search } = useLocation();
	const history = useHistory();
	const setQueryParams = useCallback((paramValues) => {
		const newSearch = toQueryString(pickBy(paramValues, identity));
		history.replace({ search: newSearch });
	}, [history]);
	return {
		queryParams: useMemo(() => {
			const params = {};
			Object.keys(defaultValues).forEach((key) => {
				params[key] = getQueryParam(search, key) ?? defaultValues[key];
			});
			return params;
		}, [defaultValues, search]),
		setQueryParams
	};
}
//#endregion
export { useUrlQueryParam as n, useUrlQueryParams as t };

//# sourceMappingURL=UrlQueryParam-Ht6uGSXZ.js.map